import on, {onMessage} from './on'

const HOST_CONTEXT = window.parent

const send = (type, message) => {
  HOST_CONTEXT.postMessage({
    type,
    message
  }, '*')
}

window.addEventListener('message', onMessage)

export {
  send,
  on
}

send('ready')

// fire the "ready" callback, (internal methods may be subscribed to this)
onMessage({
  data: {
    type: 'ready'
  }
})



// WEBPACK FOOTER //
// ./src/communication-bridge/index.js